<template>
    <div class="components-container">
        <div class="fromclass">
            <div style="border-bottom:2px solid #c8c8c8; text-align:center; height:50px; margin-bottom:10px;">
                <span style="color:#58666e; font-size:28px; font-weight:bold;">{{ title }}</span>
                <div style="float:right;">
                    <el-button :disabled="exportDisable" @click="exportkcbz()" type="success">导出</el-button>
                    <!-- <el-button v-if="gobackbuttonshow" @click="backtolastpage()" type="info">返回上一页</el-button> -->
                </div>
            </div>

            <div :style="innerDialog" class="scrollArea">
                <el-scrollbar style="height: 100%;" ref="elScrollbar">
                    <el-form :inline="true" class="small-space mainForm" :model="tableQuery" label-position="right" label-width="190px">
                        <el-form-item label="编号：">
                            <el-input style="width:610px;margin-left: 20px;" :disabled="true" name="BH" v-model="BH"
                                autoComplete="on" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="状态：">
                            <!--
                            <div style="width:610px;margin-left: 20px;">
                                <span id="ztsty" v-if="state=='0'||state==''" style="padding: 10px 15px; background: gray;color: #fff;font-size: 20;border-radius: 10px;font-weight: 600;">{{this.ZT}}</span>
                                <span id="ztsty" v-if="state=='2'||state=='1'" style="padding: 10px 15px; background: #29bc5d;color: #fff;font-size: 20;border-radius: 10px;font-weight: 600;">{{this.ZT}}</span>
                            </div>
                            -->
                            <div v-if="courseStandardState == '0'" class="status" style="background-color: #808080">
                                未保存
                            </div>
                            <div v-else-if="courseStandardState == '1'" class="status" style="background-color: #e6a23c">
                                未提交
                            </div>
                            <div v-else-if="courseStandardState=='2'" class="status" style="background-color: #409eff">
                                待审核
                            </div>
                            <div v-else-if="courseStandardState == '3'" class="status" style="background-color: #67c23a">
                                审核通过
                            </div>
                            <div v-else-if="courseStandardState == '4'" class="status" style="background-color: #f56c6c">
                                审核驳回
                            </div>
                            <div v-else></div>
                        </el-form-item>
                        <el-form-item label="起效学年：">
                            <el-select v-model="dqxnxq" clearable placeholder="请选择" :disabled="true" style="width:610px;margin-left: 20px;">
                                <el-option v-for="(item,index) in xnxq" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用专业">
                            <el-select v-model="SYZY" clearable placeholder="请选择" :disabled="true" style="width:610px;margin-left: 20px;"
                                filterable>
                                <el-option v-for="(item,index) in zy" :key="item.comboValue" :label="item.comboName"
                                    :value="item.comboValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="编制人">
                            <el-input style="width:610px;margin-left: 20px;" :disabled="true" name="BZR" v-model="BZR"
                                autoComplete="on" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="编制日期">
                            <div class="block">
                                <el-date-picker style="width:610px;margin-left: 20px;" v-model="BZRQ" name="BZRQ" align="right"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" type="datetime"
                                    placeholder="日期">
                                </el-date-picker>
                            </div>
                        </el-form-item>
                        <el-form-item label="课程">
                            <el-input style="width:1340px;margin-left: 20px;" :disabled="true" name="KC" v-model="KC" autoComplete="on"
                                maxlength="30"></el-input>
                            <el-button type="primary" :disabled="historyDisable" @click="findwnkcbz()">往年课程标准</el-button>
                        </el-form-item>

                        <div class="fromtitle new1">课程性质</div>
                        <el-input id="KCXZ" type="textarea" name="KCXZ" v-model="KCXZ" rows="3"></el-input>

                        <div class="fromtitle new1">设计思路</div>
                        <el-input id="SJSL" type="textarea" name="SJSL" v-model="SJSL" rows="3"></el-input>

                        <div class="fromtitle new1">课程目标</div>
                        <el-input id="KCMB" type="textarea" style="margin-bottom: 20px;" name="KCMB" v-model="KCMB" rows="3"></el-input>

                        <!-- <div class="fromtitle new1">课程内容与要求</div>
                        <el-input  id="KCNRYYQ" type="textarea"  :disabled="true" name="KCNRYYQ" v-model="KCNRYYQ"  rows="3"></el-input> -->

                        <div style="margin-bottom:5px;">
                            <el-button type="primary" :disabled="operateDisable" @click="addZsdlog()">新建知识点或技能点</el-button>
                            <el-button type="success" :disabled="operateDisable|| addsj" @click="editZsdlog()">编辑知识点或技能点</el-button>
                            <el-button type="danger" :disabled="operateDisable || addsj" @click="deletezsd()">删除知识点或技能点</el-button>
                        </div>
                        <el-table :data="tableData" @cell-click="handleCellClick" :cell-style="handleCellStyle"
                            :span-method="objectSpanMethod" stripe border
                            fit highlight-current-row height="600px" style="width: 100%;max-height:600px;"
                            :header-cell-style="{'font-weight': '900','color':'#58666e'}" ref="multipleTable">
                            <el-table-column :label="'工作任务 \n 一级知识点技能点'" prop="job" align="center" width="150"></el-table-column>
                            <el-table-column :label="'参考学时'" prop="time" align="center" width="100"></el-table-column>
                            <el-table-column :label="'技能与学习水平 \n 二级技能点'" prop="skill" align="center"></el-table-column>
                            <el-table-column :label="'技能与学习水平 \n 三级技能点'" align="center">
                                <template slot-scope="props">
                                    <el-table @cell-click="onsanjiRowClick" :data="props.row.slevellist" :show-header="false" align="center" stripe>
                                        <el-table-column align="center" prop="kk_mc"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column :label="'知识与学习水平 \n 二级知识点'" prop="knowlage" align="center"></el-table-column>
                            <el-table-column :label="'知识与学习水平 \n 三级知识点'" align="center">
                                <template slot-scope="props">
                                    <el-table @cell-click="onsanjiRowClick" :data="props.row.klevellist" :show-header="false" align="center" stripe>
                                        <el-table-column align="center" prop="kk_mc"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-form-item label="总课时" style="height: 90px;margin-top: 25px;">
                            <el-input style="width:1000px;" :disabled="true" name="ZKS" v-model="ZKS" autoComplete="on" maxlength="10"></el-input>
                        </el-form-item>

                        <div class="fromtitle new1">教学活动参考</div>
                        <el-input id="JXHDCK" type="textarea" name="JXHDCK" v-model="JXHDCK" rows="3"></el-input>

                        <el-form-item label="课程总学时">
                            <el-input style="width:1000px;" name="KCZXS" v-model="KCZXS" autoComplete="on" maxlength="30"></el-input>
                            <div class="zxstsy">{{zxsts}}</div>
                        </el-form-item>

                        <div style="margin-bottom: 30px;">
                            <div class="fromtitle new1">课程标准原件</div>
                            <!--
                            <el-upload style="display:inline-block" :limit="1" :data="{kk_kcbzbh: this.BH}" ref="upload"
                                :action="uploadUrl" :on-error="uploadError" :on-success="uploadSuccess"  :auto-upload="true">
                                <el-button slot="trigger" size="small"><i class="el-icon-upload2"></i>上传文件</el-button>

                                <span class="urlWJ" id="downfile" @click="downloadfile()">{{this.filename}}</span>
                            </el-upload>
                            -->
                            <div class="uploadTips" v-show="updateTipsVisible">第一次保存之后才可上传课程标准原件</div>
                            <el-col :span="3" v-show="!updateTipsVisible">
                                <el-upload ref="upload" :action="uploadUrl" :limit="1" :data="{kk_kcbzbh: this.BH}"
                                    :disabled="uploadDisable" style="margin-top:20px;"
                                    :show-file-list="false"
                                    :on-error="uploadError"
                                    :on-success="uploadSuccess"
                                    :on-remove="deleteFile"
                                    :auto-upload="true">
                                    <el-button size="small" type="success" :disabled="uploadDisable" slot="trigger">上传</el-button>
                                    <el-button size="small" type="primary" @click.stop="download" style="margin-left:10px;">下载</el-button>
                                    <el-button size="small" type="danger" :disabled="uploadDisable" @click.stop="deleteFile">删除</el-button>
                                </el-upload>
                                <div class="fileName">{{ filename }}</div>
                            </el-col>
                        </div>
                    </el-form>
                </el-scrollbar>
            </div>
            <div class="inputBox">
                <el-button :disabled="operateDisable" @click="saveMsg()" type="primary">保存</el-button>
                <el-button :disabled="operateDisable" @click="tjMsg()" type="warning">提交</el-button>
                <el-button :disabled="auditDisable" @click="showAuditDialog" type="danger">审核</el-button>
            </div>
        </div>

        <el-dialog id="wndrDialog" :title="'往年课程标准'" :visible.sync="historyVisible" style="width:100%; overflow-y:auto; top:100px;"
            class="yropen3" append-to-body>
            <div class="filter-container">
                <el-input style="width:20%;" name="wnkcbzbh" v-model="wnkcbzbh" placeholder="往年课程标准编号" maxlength="30"></el-input>
                <el-input style="width:20%;" name="wnkcbzbh" v-model="wnkcmc" placeholder="往年课程标准名称" maxlength="30"></el-input>
                <el-button @click="findwnkcbz" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            </div>
            <el-table :data="wnkcbz" stripe border fit max-height="650" v-loading="isLoading" element-loading-text="信息加载中"
                highlight-current-row ref="multipleTable2" height="450">
                <el-table-column label="编号" prop="kk_kcbzbh" align="center"></el-table-column>
                <el-table-column label="课程" prop="kcmc" align="center" width="270"></el-table-column>
                <el-table-column label="起效学年" prop="xqmc" align="center" width="220"></el-table-column>
                <el-table-column label="编制人" prop="jsmc" align="center" width="140"></el-table-column>
                <el-table-column label="操作" prop="knowlage" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button size="small" @click="CKKCBZ(scope.row);" type="success">
                            <i class="el-icon-tickets"></i>&nbsp;查看
                        </el-button>
                        <el-button :disabled="operateDisable" size="small" @click="importmsg(scope.row);" type="primary">
                            <i class="el-icon-document-copy"></i>&nbsp;导入
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div style="width:100%; height:60px; line-height:60px; color:blue; font-size:18px; text-align:center;">导入课程时仅覆盖：课程目标、课程内容与要求及教学活动参考的内容</div>
        </el-dialog>

        <!-- 新增一级知识点dialog lbj 20210202-->
        <el-dialog class="openBoxOpenBox" title="新增工作任务" :visible.sync="addZsd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">工作任务名称：</div></el-col>
                <el-col :span="18">
                    <el-input style="width: 100%;" type="text" v-model="addjobgzrw"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">参考学时：</div></el-col>
                <el-col :span="18">
                    <el-input style="width: 100%;" type="number" v-model="addjobckxs"></el-input>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="addjobzsdsave" type="primary">保存</el-button>
                <el-button @click="addZsd = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 编辑一级知识点dialog lbj 20210204-->
        <el-dialog class="openBoxOpenBox" title="编辑工作任务" :visible.sync="editZsd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">工作任务名称：</div></el-col>
                <el-col :span="18">
                    <el-input style="width: 100%;" type="text" v-model="editjobgzrw"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">参考学时：</div></el-col>
                <el-col :span="18">
                    <el-input style="width: 100%;" type="number" v-model="editjobckxs"></el-input>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="editjobzsdsave" type="primary">保存</el-button>
                <el-button @click="editZsd = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog class="openBoxOpenBox" title="新增二级技能点或知识点" :visible.sync="addejZsd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">所属工作任务：</div></el-col>
                <el-col :span="18">
                    <el-input :disabled="true" style="width: 100%;" type="text" v-model="addjobgzrw"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">二级技能点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="ejskill" @blur="selectBlur" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in ejskilllist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">二级知识点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="ejknowlage" @blur="selectBlur1" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in ejknowlagelist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="addejzsdsave" type="primary">保存</el-button>
                <el-button @click="addejZsd = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 编辑二级dialog 20210205 lbj-->
        <el-dialog class="openBoxOpenBox" title="编辑二级技能点或知识点" :visible.sync="editejZsd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">所属工作任务：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="yjeditzsd" @blur="selectBlur" :disabled="ejdisabled" filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in yjlist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">二级技能点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="ejeditskill" @blur="selectBlur4" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in ejskilllist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">二级知识点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="ejeditknowlage" @blur="selectBlur5" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in ejknowlagelist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="editejzsdsave" type="primary">保存</el-button>
                <el-button @click="editejZsd = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 新增三级知识点技能点dialog -->
        <el-dialog class="openBoxOpenBox" :title="sjadddialogtitle" :visible.sync="addsjZsdjnd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">所属二级{{ sjadddialogstr }}点：</div></el-col>
                <el-col :span="18">
                    <el-input :disabled="true" style="width:100%;" type="text" v-model="ssejmc"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">三级{{ sjadddialogstr }}点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="sjzsdjnd" @blur="selectBlur2" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in sjzsdjndlist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="addsjzsdsave" type="primary">保存</el-button>
                <el-button @click="addsjZsdjnd = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 编辑三级知识点技能点dialog -->
        <el-dialog id="addzsd" class="openBoxOpenBox" :title="sjeditdialogtitle" :visible.sync="editsjZsdjnd" top="300px" append-to-body>
            <el-row>
                <el-col :span="6"><div class="formTitle">所属二级{{ sjeditdialogstr }}点：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="sjdiassej" placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in sjssejzsdlist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><div class="formTitle">三级{{ sjeditdialogstr }}点名称：</div></el-col>
                <el-col :span="18">
                    <el-select v-model="editsjzsdjnd" @blur="selectBlur3" clearable filterable placeholder="请选择" style="width:100%;">
                        <el-option v-for="(item,index) in sjzsdjndlist" :key="index" :label="item.kk_mc" :value="item.kk_zycsbh"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button :disabled="savejz" @click="editsjzsdsave" type="primary">保存</el-button>
                <el-button @click="editsjZsdjnd = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog id="ckkcbz" class="yropen3" title="查看-课程标准" width="98%" :visible.sync="CKKBShow" :fullscreen="true" style="overflow:hidden;" append-to-body>
            <criterionforcurriculumshow v-if="CKKBShow" :KBBH="CKKBBH"></criterionforcurriculumshow>
        </el-dialog>

        <el-dialog title="审核" :visible.sync="auditDialogVisible" v-if="auditDialogVisible" width="900px" top="300px" append-to-body>
            <el-row>
                <el-col :span="24">
                    <audit ref="audit"
                        :itemCode="courseStandardInfo.auditParam"
                        :relatedCode="courseStandardInfo.id"
                        :auditLevel="courseStandardInfo.auditLevel"
                        @auditCallback="auditCallback">
                    </audit>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg } from "utils/message";
    import criterionforcurriculumshow from './criterion_for_curriculumShow.vue'
    import audit from 'views/audit/audit.vue';

    export default {
        props: ["courseStandardInfo", "KBBH"],
        components: {
            criterionforcurriculumshow,
            audit,
        },
        data() {
            return {
                userCode: null,
                userName: null,
                courseStandardState: null,
                auditDialogVisible: false,
                title: "课程标准",
                BH: "",
                ZT: "已发布",
                xnxq: [],
                dqxnxq: "",
                zy: [],
                SYZY: "",
                BZR: "",
                BZRGH: "", //编制人工号
                BZRQ: "",
                KC: "",
                KCXZ: "",
                SJSL: "",
                ZKS: "76",
                KCMB: "",
                KCNRYYQ: "",
                JXHDCK: "",
                KCZXS: "20",
                tableData: [],
                wnkcbz: [],
                spanArr1: [],
                spanArr2: [],
                spanArr3: [],
                spanArr4: [],
                spanArr5: [],
                spanArr6: [],
                historyVisible: false,
                addZsd: false,
                editZsd: false, //编辑工作任务
                addejZsd: false,
                editejZsd: false,
                addsjZsdjnd: false, //新增三级知识点技能点dialog判断
                editsjZsdjnd: false, //编辑三级知识点技能点dialog判断
                addZsdjnd: {
                    job: "",
                    time: "", //参考课时
                    knowlage: "", //二级知识点
                    kLevel: "",
                    skill: "", //二级技能点
                    sLevel: "",
                },
                addZsdjndsz: [],
                jobsz: [],
                ksz: [],
                ssz: [],
                tableQuery: {
                    limit: 100,
                    currentPage: 1,
                    rc_cjsj: null,
                    rc_ksbh: null,
                    rc_cqlx: null,
                    rc_ktbx: null,
                    rc_mkcbh: null,

                },
                addej: true, //新增二级知识点技能点按钮判断
                addsj: true, //新增三级数据按钮判断
                addzsdRow: "", //新增知识点技能点的选中行数据
                selectlevel: "", //选中行数据对应的列，用来判断选中的是第几级知识点
                operateDisable: true, //操作按钮是否可用
                auditDisable: true, //审核专用权限
                historyDisable: true, //往年课程标准专用权限
                exportDisable: true,
                uploadDisable: true,
                updateTipsVisible: true,


                addjobgzrw: "", //一级工作任务名称
                editjobgzrw: "", //编辑一级任务名称
                addjobckxs: "", //一级参考学时
                editjobckxs: "", //编辑参考学时
                ejskill: "", //二级技能点名称
                ejeditskill: "", //二级编辑技能点名称
                ejknowlage: "", //二级知识点名称
                ejeditknowlage: "", //二级编辑知识点名称
                yjlist: [], //一级知识点技能点list
                ejskilllist: [], //二级技能点list
                ejknowlagelist: [], //二级知识点list
                sjadddialogtitle: "", //新增三级dialog标题
                sjeditdialogtitle: "", //编辑三级dialog内输入框标题
                sjadddialogstr: "", //新增三级dialog内输入框标题
                sjeditdialogstr: "", //编辑三级dialog内输入框标题
                ssejmc: "", //新增三级dialog内所属二级名称
                sjzsdjndlist: [], //三级知识技能点list
                sjzsdjnd: "", //三级知识点技能点名称
                sjssejzsdlist: "", //三级编辑dia内所属二级list
                yjeditzsd: "", //二级编辑框内所属一级字段
                sjdiassej: "", //三级编辑框内所属二级字段
                editsjzsdjnd: "", //三级编辑框内三级字段
                ejdisabled: false, //二级编辑框内一级知识点权限控制
                CKKBShow: false, //查看课程标准diglog
                CKKBurl: "",
                CKKBBH: "", //查看用课标编号
                uploadUrl: globalConfig.HOST_PROXY_ADMIN + "/Kcbzzb/upload", //上传文件URL
                filename: "", //课程标准原件
                state: "", //当前状态
                DRKBBH: "", //用于导入，导入课标编号
                savejz: false,
                zxsts: "", //总学时提示语

                lastpage: globalConfig.MDL_PROXY_PATH,
                //gobackbuttonshow: false,
                kk_file: '',
                treeData: [], //树形结构信息
                bjr: "", //编辑人
                wnkcbzbh: "", //查询用的往年课标编号
                wnkcmc: "", //查询用的往年课标名称
                isLoading: false, //正在加载中
                selectRow: null,
                selectColumn: null,
                innerDialog: {
                    height: "750px",
                },
            }
        },
        mounted() {
            this.queryUserInfo();

            /* try {
                var data = location.href;
                data = '[{integrityurl:\"' + data + '\"}]'
                window.parent.postMessage(data, '*')
            } catch (e) {} */

            this.$nextTick().then(() => {
                this.innerDialog.height = window.innerHeight / 1.25 + "px";
                $(".el-dialog.is-fullscreen").css("overflow-y", "hidden");
            });
        },
        methods: {
            init(){
                if (this.KBBH != "" && this.KBBH != null && this.KBBH != undefined) {
                    this.BH = this.KBBH;
                } else {
                    this.BH = this.$route.params.kk_kcbzbh
                    //this.gobackbuttonshow = true;
                    if (document.referrer != "" && location.href != document.referrer) {
                        localStorage.setItem("kcbzgb", document.referrer);
                    }
                }

                this.KCNRYYQ = "说明：\n1.点击工作任务列，弹出工作任务、技能点、知识点的新建选项\n2.新建技能点时可选填对应知识点\n3.新建知识点时可选填对应技能点\n4.选择后将技能点和知识点进行关联，不选择时为单独的技能点或知识点\n5.单个二级技能点可对应多个二级知识点，单个二级知识点可对应多个二级技能点，但多个二级技能点不可对应多个二级知识点\n6.点击二级技能点列或二级知识点列，将新增对应技能或知识的学习水平\n";
                //this.JXHDCK="  本课程的教学活动设计是根据教学课程目标、学生实际动手操作为主；结合教学内容、教学实训设备等综合学习活动进行，以典型学习主题为载体，贯彻任务导向、项目驱动的基本理念，努力创设贴近楼宇智能化设备安装与调试实际工作岗位的学习环境和教学条件，以学生为主体、教师为主导，形成“做中学、学中做”一体的课堂教学活动。"
                this.loadzsdMsg();
                this.xnxqmsg();
                this.zymsg();
                this.loadMsg();
                this.findejzsdMsg();
            },
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    if (res.data.data) {
                        this.userName = res.data.data.name;
                        this.userCode = res.data.data.phone;

                        this.init();
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            showAuditDialog(){
                this.auditDialogVisible = true;
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.auditDialogVisible = false;
                this.updateAuditState(auditInfo);
            },
            //完成审核后更新审核状态
            updateAuditState(auditInfo){
                this.$api.courseStandard.KcbzKcbzzb.updateAuditState({
                    data: auditInfo
                }).then(response => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        this.$notify({
                            title: '成功',
                            message: '审核状态更新成功',
                            type: 'success',
                            duration: 1500,
                        });

                        this.$emit("closeDialog");
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '审核状态更新失败',
                            type: 'error',
                            duration: 1500,
                        });
                    }
                }).catch(error => {
                    this.$notify({
                        title: '错误',
                        message: '审核状态更新失败',
                        type: 'error',
                        duration: 1500,
                    });
                    console.log(error);
                });
            },
            /* @lbj
			 @2021 0513
			 @总学时验证	*/
            zxsyz(rpzxs) {
                if (rpzxs > this.KCZXS) {
                    this.zxsts = "学时不足，未达到人才培养方案的规定学时(" + rpzxs + ")";
                    $(".zxstsy").css('background', '#e7cf47');
                    $(".zxstsy").css('color', '#fff');
                } else if (rpzxs < this.KCZXS) {
                    this.zxsts = "学时过多，超出人才培养方案的规定学时(" + rpzxs + ")";
                    $(".zxstsy").css('background', '#ff2848');
                    $(".zxstsy").css('color', '#fff');
                } else {
                    this.zxsts = "";
                    $(".zxstsy").css('background', '#fff');
                }
            },
            /* @lbj
			 @2021 0301
			 @上传失败	*/
            uploadError(err, file, fileList) {
                this.$message({
                    showClose: true,
                    message: '上传失败！',
                    type: 'error'
                });
            },
            /* @lbj
			 @2021 0301
			 @上传成功	*/
            uploadSuccess(response, file, fileList) {
                if (response.data.MSG != undefined && response.data.MSG != null && response.data.MSG != 0) {
                    this.$message({
                        showClose: true,
                        message: '上传成功！',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: '上传失败！请检查是否正确保存过课程标准！',
                        type: 'warning'
                    });
                }

                this.$refs.upload.clearFiles();

                // this.filename=file.name;
                this.loadMsg();
            },
            /* @lbj
            @2021 0301
            @下载文件	*/
            /*
            downloadFile() {
                this.$parent.$parent.filename = this.filename;
                let val = globalConfig.HOST_PROXY_ADMIN_File + "/KBupload/" + this.kk_file;
                let link = document.createElement('a')
                let url = val;
                // 这里是将url转成blob地址，
                fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
                    link.href = URL.createObjectURL(blob)
                    link.download = this.filename
                    document.body.appendChild(link)
                    link.click()
                })
            },
            */
            download() {
                if (this.kk_file==null || this.kk_file=='') {
                    this.$alert("尚未上传课程标准原件", "提示", {
                        confirmButtonText: "确定",
                    });

                    return;
                }

                const fileUrl = globalConfig.HOST_PROXY_ADMIN + '/api/file/' + this.kk_file;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, this.filename);
                } else {
                    this.$notify({
                        title: "错误",
                        message: "文件不存在，如有疑问请联系管理员！",
                        type: "error",
                        duration: 3000,
                    });
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            deleteFile() {
                if (this.kk_file==null || this.kk_file=='') {
                    this.$alert("尚未上传课程标准原件", "提示", {
                        confirmButtonText: "确定",
                    });

                    return;
                }

                this.$api.courseStandard.KcbzKcbzzb.deleteFile({
                    data: {
                        id: this.BH,
                        fileUrl: this.kk_file,
                    },
                }).then((res) => {
                    this.filename = '';
                    this.kk_file = '';
                }).catch((err) => {
                    console.log(err);
                });
            },
            /* @lbj
            @2021 0301
            @上传课程标准原件	*/
            /*
            submitUpload() {
                this.$refs.upload.submit();
            },
            */
            /* @lbj
            @2021 0301
            @导入课程标准*/
            importmsg(msg) {
                let that = this
                this.$api.courseStandard.KcbzKcbzzb.checkBeforImport({
                    data: {
                        "kk_kcbzbh": that.BH,
                        "wnkcbzbh": msg.kk_kcbzbh
                    }
                }).then(response2 => {
                    //console.log(response2.data.data);
                    let flag = response2.data.data.flag
                    let showmsg = response2.data.data.MSG
                    //徐毅骏 20220120 待完善  根据返回值判断是否继续
                    //0为执行错误
                    if (flag === 0) {
                        that.$notify({
                            title: '失败',
                            message: '导入失败',
                            type: 'error',
                            duration: 1500,
                        });
                    } else {
                        that.doImport(showmsg, msg);
                    }
                }).catch(error2 => {
                    that.$notify({
                        title: '失败',
                        message: '导入失败',
                        type: 'error',
                        duration: 1500,
                    });
                    console.log(error2);
                });
            },
            doImport(showmsg, msg) {
                let that = this
                that.$confirm(showmsg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'confirm-box',
                    type: 'warning'
                }).then(() => {
                    that.$api.courseStandard.KcbzKcbzzb.importmsg({
                        data: {
                            "kk_kcbzbh": that.BH,
                            "wnkcbzbh": msg.kk_kcbzbh
                        }
                    }).then(response => {
                        if (response.data.data.MSG == 1) {
                            that.$notify({
                                title: '成功',
                                message: '导入成功',
                                type: 'success',
                                duration: 1500,
                            });

                            that.loadzsdMsg();
                            that.findejzsdMsg();
                            that.loadMsg();
                            this.historyVisible = false;
                        } else if (response.data.data.MSG == 0) {
                            that.$notify({
                                title: '失败',
                                message: '导入失败',
                                type: 'error',
                                duration: 1500,
                            });
                        }
                    }).catch(error => {
                        that.$notify({
                            title: '失败',
                            message: '导入失败',
                            type: 'error',
                            duration: 1500,
                        });
                        console.log(error);
                    });

                }).catch(() => {

                });
            },
            /* @lbj
            @2021 0301
            @查看课程标准*/
            CKKCBZ(msg) {
                this.CKKBurl = globalConfig.FONT_PROXY_PATH + "/criterion_for_curriculum/" + msg.kk_kcbzbh;
                this.CKKBBH = msg.kk_kcbzbh;
                this.DRKBBH = this.BH;
                this.CKKBShow = true;
            },
            /* @lbj
            @2021 0301
            @往年课程标准查询 */
            findwnkcbz() {
                //清空列表数据
                this.wnkcbz = []
                //先打开对话框
                this.historyVisible = true;
                this.isLoading = true
                this.$api.courseStandard.KcbzKcbzzb.findwnkcbz({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_kcbh": this.BH.substring(11, this.BH.length),
                        "kk_state": "1",
                        "wnkcbzbh": this.wnkcbzbh,
                        "kcmc": this.wnkcmc
                    }
                }).then(response => {
                    this.wnkcbz = response.data.data.MSG;
                    this.isLoading = false
                }).catch(error => {
                    console.log(error);
                    this.isLoading = false
                });

            },
            /* @lbj
            @2021 0203
            @新增二级的技能点下拉编辑框参数更新 */
            selectBlur(e) {
                if (e.target.value !== '') {
                    this.ejskill = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },
            /* @lbj
            @2021 0203
            @新增二级的技能点下拉编辑框参数更新 */
            selectBlur1(e) {
                if (e.target.value !== '') {
                    this.ejknowlage = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },
            /* @lbj
            @2021 0204
            @新增三级的技能点下拉编辑框参数更新 */
            selectBlur2(e) {
                if (e.target.value !== '') {
                    this.sjzsdjnd = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },

            /* @lbj
            @2021 0204
            @编辑三级的技能点下拉编辑框参数更新 */
            selectBlur3(e) {
                if (e.target.value !== '') {
                    this.editsjzsdjnd = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },
            /* @lbj
            @2021 0205
            @编辑三级的技能点下拉编辑框参数更新 */
            selectBlur4(e) {
                if (e.target.value !== '') {
                    this.ejeditskill = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },
            /* @lbj
            @2021 0205
            @编辑三级的技能点下拉编辑框参数更新 */
            selectBlur5(e) {
                if (e.target.value !== '') {
                    this.ejeditknowlage = e.target.value;
                    this.$forceUpdate() // 强制更新
                }
            },
            /* @lbj
            @2021 0204
            @新增三级的知识点 */
            addsjzsdsave() {
                var kk_lx = "";
                var kk_sjkcnrbh = "";
                var kk_ckxs = "";
                var kk_bh = "";
                this.savejz = true;
                if (this.addzsdRow.jobid != undefined) {
                    //选中的三级本身一条数据都没
                    if (this.selectlevel == "kLevel") {
                        kk_lx = "K";
                        kk_sjkcnrbh = this.addzsdRow.knowlagezycsbh;
                        kk_ckxs = this.addzsdRow.time;
                        kk_bh = this.addzsdRow.knowlagebh + "-" + (this.sjzsdjndlist.length + 1);
                    } else if (this.selectlevel == "sLevel") {
                        kk_lx = "S";
                        kk_sjkcnrbh = this.addzsdRow.skillzycsbh;
                        kk_ckxs = this.addzsdRow.time;
                        kk_bh = this.addzsdRow.skillbh + "-" + (this.sjzsdjndlist.length + 1);
                    }
                } else {
                    //选中的三级本身有其他数据
                    if (this.selectlevel == "kLevel") {
                        kk_lx = "K";
                        kk_sjkcnrbh = this.addzsdRow.kk_sjkcnrbh;
                        kk_ckxs = this.addzsdRow.kk_ckxs;
                        kk_bh = this.addzsdRow.ejbh + "-" + (this.sjzsdjndlist.length + 1);
                    } else if (this.selectlevel == "sLevel") {
                        kk_lx = "S";
                        kk_sjkcnrbh = this.addzsdRow.kk_sjkcnrbh;
                        kk_ckxs = this.addzsdRow.kk_ckxs;
                        kk_bh = this.addzsdRow.ejbh + "-" + (this.sjzsdjndlist.length + 1);
                    }
                }
                //2021 0507 lbj 从人陪单独打开课标页面可能会没有当前登录人数据，没有则给定固定创建者
                let userGH = "admin";
                if (localStorage.getItem("user") != null && localStorage.getItem("user") != undefined && localStorage.getItem(
                        "user") != null) {
                    userGH = localStorage.getItem("user");
                }
                this.$api.courseStandard.KcbzKcnryyq.addsjzsd({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_zycsbh": this.sjzsdjnd,
                        "kk_ckxs": kk_ckxs,
                        "kk_lx": kk_lx,
                        "kk_sjkcnrbh": kk_sjkcnrbh,
                        "kk_bh": kk_bh,
                        "kk_cjr": userGH
                    }
                }).then(response => {
                    if (response.data.data == 1) {
                        this.$notify({
                            title: '成功',
                            message: '新增成功',
                            type: 'success',
                            duration: 1500,
                        });
                        this.loadzsdMsg();
                        this.addsjZsdjnd = false;
                        this.sjzsdjnd = "";
                    } else if (response.data.data == 2) {
                        this.$notify({
                            title: '提示',
                            message: '需要生成的数据已存在，无需重复新增',
                            type: 'warning',
                            duration: 1500,
                        });
                        this.loadzsdMsg();
                        this.addsjZsdjnd = false;
                        this.sjzsdjnd = "";
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '新增失败',
                            type: 'error',
                            duration: 1500,
                        });
                        this.addZsd = false;
                    }
                    this.savejz = false;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
            @2021 0204
            @编辑三级的知识点保存 */
            editsjzsdsave() {
                this.savejz = true;
                this.$api.courseStandard.KcbzKcnryyq.editsjzsd({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_zycsbh": this.editsjzsdjnd,
                        "kk_sjkcnrbh": this.sjdiassej,
                        "kk_kcnrbh": this.addzsdRow.kk_kcnrbh,
                        "kk_cjr": localStorage.getItem("user")
                    }
                }).then(response => {
                    if (response.data.data == 1) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success',
                            duration: 1500,
                        });
                        this.loadzsdMsg();
                        this.editsjZsdjnd = false;
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '修改失败',
                            type: 'error',
                            duration: 1500,
                        });
                        this.addZsd = false;
                    }
                    this.savejz = false;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
            @2021 0203
            @新增二级的知识点 */
            addejzsdsave() {
                this.savejz = true;
                //2021 0507 lbj 从人陪单独打开课标页面可能会没有当前登录人数据，没有则给定固定创建者
                let userGH = "2";
                if (localStorage.getItem("user") != null && localStorage.getItem("user") != undefined && localStorage.getItem(
                        "user") != null) {
                    userGH = localStorage.getItem("user");
                }
                this.$api.courseStandard.KcbzKcnryyq.addejzsd({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_ejjndbh": this.ejskill,
                        "kk_ejzsdbh": this.ejknowlage,
                        "kk_gzrwbh": this.addzsdRow.jobid,
                        "time": this.addzsdRow.time,
                        "kk_kcnrgxbh": this.addzsdRow.glbid,
                        "kk_cjr": userGH
                    }
                }).then(response => {
                    if (response.data.data == 1) {
                        this.$notify({
                            title: '成功',
                            message: '新增成功',
                            type: 'success',
                            duration: 1500,
                        });
                        this.loadzsdMsg();
                        this.addejZsd = false;
                        this.ejskill = "";
                        this.ejknowlage = "";
                        this.findejzsdMsg();
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '新增失败',
                            type: 'error',
                            duration: 1500,
                        });
                        this.addZsd = false;
                    }
                    this.savejz = false;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
            @2021 0205
            @编辑二级的知识点 */
            editejzsdsave() {
                this.savejz = true;
                this.$api.courseStandard.KcbzKcnryyq.editejzsd({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_kcnrgxbh": this.addzsdRow.glbid,
                        "kk_gzrwbh": this.yjeditzsd,
                        "kk_ejjndbh": this.ejeditskill,
                        "kk_ejzsdbh": this.ejeditknowlage,
                        "time": this.addzsdRow.time,
                        "jobbh": this.addzsdRow.jobbh,
                        "kk_cjr": localStorage.getItem("user")
                    }
                }).then(response => {
                    if (response.data.data == 1) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success',
                            duration: 1500,
                        });
                        this.editejZsd = false;
                        this.loadzsdMsg();
                        this.findejzsdMsg();
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '修改失败',
                            type: 'error',
                            duration: 1500,
                        });
                        this.addZsd = false;
                    }
                    this.savejz = false;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
            @2021 0202
            @新增一级的知识点 */
            addjobzsdsave() {
                if (this.addjobgzrw == "") {
                    this.$message({
                        showClose: true,
                        message: '请输入工作任务！',
                        type: 'warning'
                    });
                } else if (this.addjobckxs == "") {
                    this.$message({
                        showClose: true,
                        message: '请输入参考学时！',
                        type: 'warning'
                    });
                } else {
                    this.savejz = true;
                    //2021 0507 lbj 从人陪单独打开课标页面可能会没有当前登录人数据，没有则给定固定创建者
                    let userGH = "admin";
                    if (localStorage.getItem("user") != null && localStorage.getItem("user") != undefined &&
                        localStorage.getItem("user") != null) {
                        userGH = localStorage.getItem("user");
                    }
                    this.$api.courseStandard.KcbzKcnryyq.addjobzsd({
                        data: {
                            "kk_kcbzbh": this.BH,
                            "kk_mc": this.addjobgzrw,
                            "kk_ckxs": this.addjobckxs,
                            "kk_cjr": userGH
                        }
                    }).then(response => {
                        this.savejz = false;
                        if (response.data.data == 1) {
                            this.$notify({
                                title: '成功',
                                message: '新增成功',
                                type: 'success',
                                duration: 1500,
                            });
                            this.findejzsdMsg();
                            this.loadzsdMsg();
                            this.addZsd = false;
                            this.addjobgzrw = "";
                            this.addjobckxs = "";
                        } else {
                            this.$notify({
                                title: '错误',
                                message: '新增失败',
                                type: 'error',
                                duration: 1500,
                            });
                            this.addZsd = false;
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            /* @lbj
            @2021 0204
            @编辑一级工作任务 */
            editjobzsdsave() {
                this.savejz = true;
                this.$api.courseStandard.KcbzKcnryyq.editjobzsd({
                    data: {
                        "kk_kcnrbh": this.addzsdRow.jobid,
                        "kk_mc": this.editjobgzrw,
                        "kk_ckxs": this.editjobckxs,
                        "kk_cjr": localStorage.getItem("user")
                    }
                }).then(response => {
                    if (response.data.data == 1) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success',
                            duration: 1500,
                        });
                        this.loadzsdMsg();
                        this.editZsd = false;
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '修改失败',
                            type: 'error',
                            duration: 1500,
                        });
                        this.editZsd = false;
                    }
                    this.savejz = false;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
			    @2021 0202
				@删除选中的知识点 */
            deletezsd() {
                if (this.addzsdRow == undefined) {
                    this.$message({
                        showClose: true,
                        message: '请选择需要删除的数据！',
                        type: 'warning'
                    });
                } else {
                    if (this.addzsdRow.slevellist != undefined && this.selectlevel == "sLevel") {
                        if (this.addzsdRow.slevellist.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '当前选中数据内无数据，无法删除！',
                                type: 'warning'
                            });
                        }
                    } else if (this.addzsdRow.klevellist != undefined && this.selectlevel == "kLevel") {
                        if (this.addzsdRow.klevellist.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '当前选中数据内无数据，无法删除！',
                                type: 'warning'
                            });
                        }
                    } else if (this.addzsdRow.skill == "" && this.selectlevel == "skill") {
                        this.$message({
                            showClose: true,
                            message: '当前选中数据内无数据，无法删除！',
                            type: 'warning'
                        });
                    } else if (this.addzsdRow.knowlage == "" && this.selectlevel == "knowlage") {
                        this.$message({
                            showClose: true,
                            message: '当前选中数据内无数据，无法删除！',
                            type: 'warning'
                        });
                    } else {
                        var delmsg = "";
                        if (this.selectlevel == "sLevel" || this.selectlevel == "kLevel") {
                            delmsg = "确定删除 " + this.addzsdRow.kk_mc + "么？"
                        } else if (this.selectlevel == "knowlage") {
                            delmsg = "确定删除 " + this.addzsdRow.knowlage + "么？"
                        } else if (this.selectlevel == "skill") {
                            delmsg = "确定删除 " + this.addzsdRow.skill + "么？"
                        } else if (this.selectlevel == "job") {
                            delmsg = "确定删除 " + this.addzsdRow.job + "以及下面所有的数据么？"
                        }
                        this.$confirm(delmsg, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            customClass: 'confirm-box',
                            type: 'warning'
                        }).then(() => {
                            this.savejz = true;
                            this.addsj = true;
                            var sLevel = "";
                            var kLevel = "";
                            if (this.selectlevel == "sLevel") {

                                sLevel = this.addzsdRow.kk_kcnrbh;
                            } else if (this.selectlevel == "kLevel") {
                                kLevel = this.addzsdRow.kk_kcnrbh;
                            }
                            // console.log({
                            // 	 "glbid":this.addzsdRow.glbid,
                            // 	 "selectlevel":this.selectlevel,
                            // 	 "jobid":this.addzsdRow.jobid,
                            // 	 "knowlageid":this.addzsdRow.knowlageid,
                            // 	 "skillid":this.addzsdRow.skillid,
                            // 	 "sLevelid":sLevel,
                            // 	 "kLevelid":kLevel,
                            // 	 "kk_kcbzbh":this.BH
                            //  })
                            this.$api.courseStandard.KcbzKcnryyq.deleteMsg({
                                data: {
                                    "glbid": this.addzsdRow.glbid,
                                    "selectlevel": this.selectlevel,
                                    "jobid": this.addzsdRow.jobid,
                                    "knowlageid": this.addzsdRow.knowlageid,
                                    "skillid": this.addzsdRow.skillid,
                                    "sLevelid": sLevel,
                                    "kLevelid": kLevel,
                                    "kk_kcbzbh": this.BH
                                }
                            }).then(response => {
                                if (response.data.data == 1) {
                                    this.$notify({
                                        title: '成功',
                                        message: '删除成功',
                                        type: 'success',
                                        duration: 1500,
                                    });
                                    this.loadzsdMsg();
                                    this.findejzsdMsg();
                                } else {
                                    this.$notify({
                                        title: '错误',
                                        message: '删除失败',
                                        type: 'error',
                                        duration: 1500,
                                    });
                                }
                                this.savejz = false;
                            }).catch(error => {
                                console.log(error);
                            });
                            this.addzsdRow = "";
                        }).catch(() => {});
                    }
                }
            },
            dateFormat(time) {
                var date = new Date(time);
                var year = date.getFullYear();
                var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
                var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                // 拼接
                return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            },
            //2021 0506 lbj 数据提交方法
            tjMsg() {
                confirmMsg('提交后将无法再次修改当前课程标准，是否继续？').then(() => {
                    this.submitRec();
                });
            },
            submitRec(){
                this.$api.courseStandard.KcbzKcbzzb.update({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_qxxn": this.dqxnxq,
                        "kk_syzy": this.SYZY,
                        "kk_bzrq": this.BZRQ,
                        "kk_kcxz": this.KCXZ,
                        "kk_kcbh": this.BH.substring(11, 21),
                        "kk_sjsl": this.SJSL,
                        "kk_kcmb": this.KCMB,
                        "kk_jxhdck": this.JXHDCK,
                        "kk_kczxs": this.KCZXS,
                        "kk_bzr": this.BZRGH,
                        "kk_tjzt": "1",
                        "kk_shzt": "",
                        "kk_state": "1",
                    }
                }).then(response => {
                    if (response.data.data.MSG == 1) {
                        this.$notify({
                            title: '成功',
                            message: '提交成功',
                            type: 'success',
                            duration: 1500,
                        });

                        this.$emit("closeDialog");
                        //this.loadMsg();
                    } else {
                        this.$notify({
                            title: '错误',
                            message: '提交失败',
                            type: 'error',
                            duration: 1500,
                        });
                    }
                }).catch(error => {
                    this.$notify({
                        title: '错误',
                        message: '提交失败',
                        type: 'error',
                        duration: 1500,
                    });
                    console.log(error);
                });
            },
            //2021 0506 lbj 数据保存方法
            saveMsg() {
                this.$api.courseStandard.KcbzKcbzzb.update({
                    data: {
                        "kk_kcbzbh": this.BH,
                        "kk_qxxn": this.dqxnxq,
                        "kk_syzy": this.SYZY,
                        "kk_bzrq": this.BZRQ,
                        "kk_kcxz": this.KCXZ,
                        "kk_kcbh": this.BH.substring(11, 21),
                        "kk_sjsl": this.SJSL,
                        "kk_kcmb": this.KCMB,
                        "kk_jxhdck": this.JXHDCK,
                        "kk_kczxs": this.KCZXS,
                        "kk_bzr": this.BZRGH,
                        "kk_state": "1",
                        "kk_tjzt": "0",
                    }
                }).then(response => {
                    if (response.data.data.MSG == 1) {
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success',
                            duration: 1500,
                        });

                        this.loadMsg();
                    } else {
                        this.$notify({
                            title: '保存失败',
                            message: '保存失败！请正确填写必填数据，适用专业，起效学年，编制日期！',
                            type: 'error',
                            duration: 1500,
                        });
                    }
                }).catch(error => {
                    this.$notify({
                        title: '保存失败',
                        message: '保存失败！请正确填写必填数据，适用专业，起效学年，编制日期！',
                        type: 'error',
                        duration: 1500,
                    });
                });
            },
            /*
            gojxwj() {
                parent.clickLink(globalConfig.FONT_PROXY_PATH + "/TeachingDocument");
            },
            */
            /*
            tableRowClassName({
                row,
                rowIndex
            }) {
                row.row_index = rowIndex;
                //绑定表格下标到row里
            },
            */
            /* @lbj
            @2021 0202
            @点击单元格解锁按钮并获得数据 */
            handleCellClick(row, column, cell, event) {
                this.selectRow = row;
                this.selectColumn = column;

                //点击获取下标
                if (column.label.indexOf("一级知识点") > -1) {
                    this.selectlevel = "job"
                } else if (column.label.indexOf("二级知识点") > -1) {
                    this.selectlevel = "knowlage"
                } else if (column.label.indexOf("二级技能点") > -1) {
                    this.selectlevel = "skill"
                } else if (column.label.indexOf("三级知识点") > -1) {
                    this.selectlevel = "kLevel"
                } else if (column.label.indexOf("三级技能点") > -1) {
                    this.selectlevel = "sLevel"
                }
                this.addzsdRow = row;
                if (row != undefined) {
                    this.addsj = false;
                } else {
                    this.addsj = true;
                }
            },
            /* @lbj
            @2021 0202
            @点击三级单元格解锁按钮并获得数据 */
            onsanjiRowClick(row, column, cell, event) {
                if (row.kk_lx == "S") {
                    this.selectlevel = "sLevel"
                } else if (row.kk_lx == "K") {
                    this.selectlevel = "kLevel"
                }
                this.addzsdRow = row;
                if (row != undefined) {
                    this.addsj = false;
                } else {
                    this.addsj = true;
                }
            },
            jobonInputBlur() {
                for (var i = 0; i < this.addZsdjndsz.length; i++) {
                    if (this.addZsdjndsz[i].job != "") {
                        this.addej = false;
                        break;
                    } else {
                        this.addej = true;
                    }
                }
            },
            /* @lbj
            @2021 0204
            @打开编辑dialog */
            editZsdlog() {
                this.savejz = false;
                this.ejdisabled = false;
                if (this.selectlevel == "job") {
                    this.editjobgzrw = this.addzsdRow.job.substring(this.addzsdRow.job.indexOf("]") + 2, this.addzsdRow
                        .job.length);
                    this.editjobckxs = this.addzsdRow.time;
                    this.editZsd = true;
                } else if (this.selectlevel == "sLevel") {
                    if (this.addzsdRow.kk_sjkcnrbh != undefined) {
                        this.sjeditdialogtitle = "编辑三级技能点";
                        this.sjssejzsdlist = this.ejskilllist;
                        this.sjdiassej = this.addzsdRow.kk_sjkcnrbh
                        this.editsjzsdjnd = this.addzsdRow.kk_zycsbh
                        this.findsjzsdMsg("S");
                        this.editsjZsdjnd = true;
                        this.sjeditdialogstr = "技能";
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请选择要编辑的三级知识点技能点数据！',
                            type: 'warning'
                        });
                    }

                } else if (this.selectlevel == "kLevel") {
                    if (this.addzsdRow.kk_sjkcnrbh != undefined) {
                        this.sjeditdialogtitle = "编辑三级知识点";
                        this.sjssejzsdlist = this.ejknowlagelist;
                        this.sjdiassej = this.addzsdRow.kk_sjkcnrbh
                        this.editsjzsdjnd = this.addzsdRow.kk_zycsbh
                        this.findsjzsdMsg("K");
                        this.sjeditdialogstr = "知识";
                        this.editsjZsdjnd = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请选择要编辑的三级知识点技能点数据！',
                            type: 'warning'
                        });
                    }

                } else if (this.selectlevel == "knowlage" || this.selectlevel == "skill") {
                    this.editejZsd = true;
                    this.ejeditknowlage = this.addzsdRow.knowlagezycsbh;
                    this.ejeditskill = this.addzsdRow.skillzycsbh;
                    this.yjeditzsd = this.addzsdRow.jobzycsbh;
                } else {
                    this.$message({
                        showClose: true,
                        message: '请选择要编辑的单元格！',
                        type: 'warning'
                    });
                }
            },
            addZsdlog() {
                //打开新增知识点技能点dlog
                this.savejz = false;
                if (this.selectlevel == "job" || this.selectlevel == "") {
                    this.addjobgzrw = "";
                    this.addZsd = true;
                } else if (this.selectlevel == "knowlage" || this.selectlevel == "skill") {
                    this.addejZsd = true;
                    this.addjobgzrw = this.addzsdRow.job;
                } else if (this.selectlevel == "sLevel") {
                    if (this.addzsdRow.skillid == "") {
                        if (this.addzsdRow.slevellist.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '当前选中数据无二级数据，请选择有二级数据的三级数据！',
                                type: 'warning'
                            });
                        }
                    } else {
                        this.sjadddialogtitle = "新增三级技能点";
                        this.sjadddialogstr = "技能";
                        this.findsjzsdMsg("S");
                        if (this.addzsdRow.skill != undefined) {
                            this.ssejmc = this.addzsdRow.skill;
                        } else {
                            this.ssejmc = "[" + this.addzsdRow.ejbh + "]." + this.addzsdRow.ejmc;
                        }
                        this.sjzsdjnd = "";
                        this.addsjZsdjnd = true;
                    }
                } else if (this.selectlevel == "kLevel") {
                    if (this.addzsdRow.knowlageid == "") {
                        this.$message({
                            showClose: true,
                            message: '当前选中数据无二级数据，请选择有二级数据的三级数据！',
                            type: 'warning'
                        });
                    } else {
                        this.sjadddialogtitle = "新增三级知识点";
                        this.sjadddialogstr = "知识";
                        this.findsjzsdMsg("K");
                        if (this.addzsdRow.knowlage != undefined) {
                            this.ssejmc = this.addzsdRow.knowlage;
                        } else {
                            this.ssejmc = "[" + this.addzsdRow.ejbh + "]." + this.addzsdRow.ejmc;
                        }
                        this.sjzsdjnd = "";
                        this.addsjZsdjnd = true;
                    }
                }
            },
            /*
            kfz() {
                alert("功能开发中");
            },
            */
            zymsg() {
                //专业下拉框
                this.$api.common.comboOption.major().then(response => {
                    this.zy = response.data.data.comboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 学年学期下拉框
            xnxqmsg() {
                this.$api.common.comboOption.year().then(response => {
                    this.xnxq = response.data.data.comboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 数据合并方法
            getSpanArr(data) {
                this.ZKS = 0;
                //this.KCZXS=0;
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr1.push(1);
                        this.pos = 0
                        this.ZKS += parseInt(data[i].time);
                        //this.KCZXS+=parseInt(data[i].time);
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].job === data[i - 1].job) {
                            this.spanArr1[this.pos] += 1;
                            this.spanArr1.push(0);
                        } else {
                            this.ZKS += parseInt(data[i].time);
                            //this.KCZXS+=parseInt(data[i].time);
                            this.spanArr1.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr2.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].time === data[i - 1].time) {
                            this.spanArr2[this.pos] += 1;
                            this.spanArr2.push(0);
                        } else {
                            this.spanArr2.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr3.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].skill != "" && data[i - 1].skill != "") {
                            if (data[i].skill === data[i - 1].skill) {
                                this.spanArr3[this.pos] += 1;
                                this.spanArr3.push(0);
                            } else {
                                this.spanArr3.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr3.push(1);
                            this.pos = i;
                        }
                    }
                }
                //三级技能点
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr4.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].slevellist.length != 0 && data[i - 1].slevellist.length != 0) {
                            //新增判断，如果没有任何二级则直接判断不相等 2021 0202 lbj
                            /* 						   console.log(data[i].slevellist[0].kk_mc);
                            						   console.log(data[i-1].slevellist[0].kk_mc);
                            						   console.log(data[i].slevellist[0].kk_sjkcnrbh);
                            						   console.log(data[i - 1].slevellist[0].kk_sjkcnrbh); */
                            if (data[i].slevellist[0].kk_sjkcnrbh === data[i - 1].slevellist[0].kk_sjkcnrbh) {
                                this.spanArr4[this.pos] += 1;
                                this.spanArr4.push(0);
                            } else {
                                this.spanArr4.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr4.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr5.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].knowlage != "" && data[i - 1].knowlage != "") {
                            if (data[i].knowlage === data[i - 1].knowlage) {
                                this.spanArr5[this.pos] += 1;
                                this.spanArr5.push(0);
                            } else {
                                this.spanArr5.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr5.push(1);
                            this.pos = i;
                        }
                    }
                }
                //三级知识点
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr6.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同

                        if (data[i].klevellist.length != 0 && data[i - 1].klevellist.length != 0) {
                            //新增判断，如果没有任何二级则直接判断不相等 2021 0202 lbj
                            if (data[i].klevellist[0].kk_sjkcnrbh === data[i - 1].klevellist[0].kk_sjkcnrbh) {
                                this.spanArr6[this.pos] += 1;
                                this.spanArr6.push(0);
                            } else {
                                this.spanArr6.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr6.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            objectSpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (columnIndex === 0) {
                    const _row = this.spanArr1[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 1) {
                    const _row = this.spanArr1[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 2) {
                    const _row = this.spanArr3[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 3) {
                    const _row = this.spanArr4[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 4) {
                    const _row = this.spanArr5[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 5) {
                    const _row = this.spanArr6[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            /* @WHY
              @2021 0610
              @导出课程标准	*/
            exportkcbz() {
                this.$api.courseStandard.KcbzKcbzzb.export({
                    data: {
                        "kk_kcbzbh": this.BH,
                    }
                }).then(response => {
                    if (response.data == true) {
                        // this.$notify({
                        //     title: '导出',
                        //     message: '导出成功',
                        //     type: 'success',
                        //     duration: 1500,
                        // });
                        // let link = globalConfig.MDL_PROXY_PATH.substring(0, globalConfig.MDL_PROXY_PATH.indexOf(
                        //     "/core")) + "/skjh/files/" + "KCBZ" + this.BH + ".xls"
                        // //let link =globalConfig.MDL_PROXY_PATH.substring(0,globalConfig.MDL_PROXY_PATH.indexOf("/core"))+"/skjh/files/"+"SKJH"+this.tableQuery.BH+".xls"
                        // var a = document.createElement('a');
                        // a.href = link
                        // a.download = this.title + this.BH + ".xls";
                        // a.click();

                        const fileName = "KCBZ" + this.BH + ".xls";
                        const fileUrl = globalConfig.HOST_PROXY_ADMIN + '/api/file/tempFile/' + fileName;
                        let exist = this.isExistFile(fileUrl);
                        if (exist) {
                            this.downloadFile(fileUrl, fileName);
                        } else {
                            this.$notify({
                                title: "错误",
                                message: "文件不存在，如有疑问请联系管理员！",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    } else {
                        this.$notify({
                            title: '导出',
                            message: '导出失败',
                            type: 'error',
                            duration: 1500,
                        });
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            //查询该课程编辑人信息
            bjrMsg(kcxx) {
                var container = {}
                if (kcxx != "") {
                    //已保存数据 直接获取编辑人
                    //container.idnumber=kcxx.kk_kcbh
                    this.bjr = kcxx.kk_bzr
                    //console.log("this.bjr="+this.bjr)
                    //console.log("user="+localStorage.getItem("user"))
                    //未保存，当前用户属于配置编辑人
                    //if(this.bjr.indexOf(localStorage.getItem("user"))!=-1){
                    if (this.bjr == localStorage.getItem("user")) {
                        //console.log("登录人是数据编辑人")
                        //当前用户属于编辑人，保存提交可用
                        this.anQX = false;
                        this.anQX2 = false;
                    } else {
                        this.anQX = true;
                    }
                } else {
                    //未创建的数据 截取课标编号
                    container.category = this.BH.substring(11, 21)
                    container.bjr = localStorage.getItem("user")
                    //向后台请求实际编辑人
                    this.$api.courseStandard.kcbzBjrController.getBjrByKCBZ({
                        data: container
                    }).then(response => {
                        //console.log(response.data.data.list)
                        let list = response.data.data.list
                        //查到数据，当前登录人是可编辑人
                        if (list.length > 0) {
                            this.bjr = list[0].bjr
                        }
                        //未保存，当前用户属于配置编辑人
                        //if(this.bjr.indexOf(localStorage.getItem("user"))!=-1){
                        if (this.bjr == localStorage.getItem("user")) {
                            //当前用户属于编辑人，保存提交可用
                            this.anQX = false;
                            //this.anQX2=false;
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }
            },
            //课程树形结构查询
            treeMsg(id) {
                this.$api.electives.public.catagorys2({
                    data: ""
                }).then(response => {
                    this.treeData = response.data.data.catagorylist
                    var parentMsg = this.getParentsById(this.treeData, id)

                    for (var i = 0; i < parentMsg.length; i++) {
                        if (parentMsg[i].bjrgh != null) {
                            this.bjr = this.bjr + parentMsg[i].bjrgh + ","
                        }
                    }
                }).catch(error => {
                    console.log("专业结构查询出错")
                    console.log(error)
                });
            },
            //获取该节点的父节点信息
            getParentsById(list, id) {
                console.log(list)
                console.log(id)
                for (let i in list) {
                    if (list[i].id === id) {
                        //查询到就返回该数组对象
                        return [list[i]]
                    }
                    if (list[i].child) {
                        let node = this.getParentsById(list[i].child, id)
                        if (node !== undefined) {
                            //查询到把父节点连起来
                            return node.concat(list[i])
                        }
                    }
                }
            },
            //2021 0506 lbj 数据加载方法
            loadMsg() {
                let that = this
                //WHY1数据加载
                this.$api.courseStandard.KcbzKcbzzb.queOne({
                    data: {
                        kk_kcbzbh: this.BH
                    }
                }).then(response => {
                    const courseStandardInfo = response.data.data.MSG;

                    if (courseStandardInfo) {
                        this.exportDisable = false;
                        this.historyDisable = false;
                        this.updateTipsVisible = false;
                        //查询该课程编辑人信息
                        //this.bjrMsg(response.data.data.MSG)

                        if (courseStandardInfo.kk_tjzt == "0") {
                            this.courseStandardState = '1';
                            //this.ZT = "已保存";
                            //console.log(localStorage.getItem("user"))
                            // console.log(response.data.data.MSG.kk_bzr)
                            // console.log(localStorage.getItem("user")==response.data.data.MSG.kk_bzr)
                            //当前用户为编制人时，可编辑
                            if (this.userCode == courseStandardInfo.kk_bzr) {
                                this.operateDisable = false;
                                this.uploadDisable = false;
                                this.auditDisable = true;
                            }
                            /*
                            else if (response.data.data.MSG.kk_bzr == null
                                    || response.data.data.MSG.kk_bzr == undefined
                                    || response.data.data.MSG.kk_bzr == "") {
                                //当前编制人为空，查询配置编辑人信息
                                //var bjr=this.bjrMsg(response.data.data.MSG)
                                //if(bjr.localStorage.getItem("user"))
                                //if(this.bjr.indexOf(localStorage.getItem("user"))!=-1){
                                if (this.bjr == localStorage.getItem("user")) {
                                    //当前用户属于编辑人，保存提交可用
                                    this.anQX = false;
                                }
                            }
                            */
                            else {
                                this.operateDisable = true;
                                this.uploadDisable = true;
                                this.auditDisable = true;
                            }
                            //编制教师为空且当前用户角色为教师，保存、提交按钮可用
                            /*
                            if (localStorage.getItem("userType") == 3 && (this.BZR == "" || this.BZR == null ||
                                    this.BZJS == undefined)) {
                                this.anQX = false;
                            }
                            */
                        } else if (courseStandardInfo.kk_tjzt == "1" && courseStandardInfo.kk_shzt=='') {
                            this.courseStandardState = '2';
                            //this.ZT = "已提交";
                            this.auditDisable = false;
                            this.operateDisable = true;
                        } else if (courseStandardInfo.kk_shzt == "1") {
                            this.courseStandardState = '3';
                            //this.ZT = "已发布";
                            this.operateDisable = true;
                            this.uploadDisable = true;
                            this.auditDisable = true;

                        } else if (courseStandardInfo.kk_shzt == '2'){
                            this.courseStandardState = '4';
                            this.operateDisable = false;
                            this.uploadDisable = false;
                            this.auditDisable = true;
                        }else{
                            this.courseStandardState = '0';
                            this.operateDisable = true;
                            this.uploadDisable = true;
                            this.auditDisable = true;
                        }

                        this.BZR = courseStandardInfo.jsmc
                        if (courseStandardInfo.kk_bzrq != null && courseStandardInfo.kk_bzrq != "") {
                            this.BZRQ = response.data.data.MSG.kk_bzrq;
                        } else {
                            this.BZRQ = this.dateFormat(new Date());
                        }
                        this.dqxnxq = courseStandardInfo.kk_qxxn
                        this.KCMB = courseStandardInfo.kk_kcmb
                        this.KCXZ = courseStandardInfo.kk_kcxz
                        this.SJSL = courseStandardInfo.kk_sjsl
                        this.JXHDCK = courseStandardInfo.kk_jxhdck
                        this.SYZY = courseStandardInfo.kk_syzy
                        this.KCZXS = courseStandardInfo.kk_kczxs
                        this.filename = courseStandardInfo.kk_filename
                        this.kk_file = courseStandardInfo.kk_file
                        if (courseStandardInfo.kcmc == undefined || courseStandardInfo.kcmc == null) {
                            courseStandardInfo.kcmc = ""
                        }
                        this.title = courseStandardInfo.kcmc + "课程标准";
                        this.BZRGH = courseStandardInfo.kk_bzr;
                        //this.CKKBurl = courseStandardInfo.kk_fileurl;
                        this.state = courseStandardInfo.kk_state;
                        this.KC = this.BH.substring(this.BH.length - 10, this.BH.length) + "-" + courseStandardInfo.kcmc;
                        this.zxsyz(courseStandardInfo.rpzxs);
                    } else {
                        this.courseStandardState = '0';
                        //this.ZT = "未保存";
                        //$("#ztsty").css("background", "gray")
                        //没查到数据只存在bh的情况下自动填充部分数据
                        //that.BZR = localStorage.getItem("uName");
                        //that.BZRGH = localStorage.getItem("user");
                        this.BZR = this.userName;
                        this.BZRGH = this.userCode;

                        //查询该课程编辑人信息
                        //this.bjrMsg("")
                        this.operateDisable = false;
                        this.uploadDisable = true;
                        this.auditDisable = true;
                        this.historyDisable = true;

                        if(this.courseStandardInfo){
                            this.dqxnxq = this.courseStandardInfo.year;
                            this.SYZY = this.courseStandardInfo.majorCode;
                            this.KC = this.courseStandardInfo.courseCode + "-" + this.courseStandardInfo.courseName;
                            this.BZRQ = this.dateFormat(new Date());
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 知识点表格数据加载方法
            loadzsdMsg() {
                this.$api.courseStandard.KcbzKcnryyq.queList({
                    data: {
                        kk_kcbzbh: this.BH
                    }
                }).then(response => {
                    this.spanArr1 = [];
                    this.spanArr2 = [];
                    this.spanArr3 = [];
                    this.spanArr4 = [];
                    this.spanArr5 = [];
                    this.spanArr6 = [];
                    this.getSpanArr(response.data.data);
                    this.tableData = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
            /* @lbj
			@2021 0203
			@二级知识点技能点下拉框数据 */
            findejzsdMsg() {
                this.$api.courseStandard.KcbzKcnryyq.findejzsdjnd({
                    data: {
                        "kk_cj": "2",
                        "kk_lx": "K",
                        "kk_kcbzbh": this.BH
                    }
                }).then(response => {
                    if (response.data.data.length > 0) {
                        this.ejknowlagelist = response.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                });

                this.$api.courseStandard.KcbzKcnryyq.findejzsdjnd({
                    data: {
                        "kk_cj": "2",
                        "kk_lx": "S",
                        "kk_kcbzbh": this.BH
                    }
                }).then(response => {
                    if (response.data.data.length > 0) {
                        this.ejskilllist = response.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                });

                this.$api.courseStandard.KcbzKcnryyq.findyjzsdjnd({
                    data: {
                        "kk_cj": "1",
                        "kk_kcbzbh": this.BH
                    }
                }).then(response => {
                    if (response.data.data.length > 0) {
                        this.yjlist = response.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            //三级级知识点技能点下拉框数据
            findsjzsdMsg(kk_lx) {
                var kk_sjkcnrbh = "";
                if (this.addzsdRow.jobid != undefined) {
                    //选中的三级本身一条数据都没
                    if (kk_lx == "K") {
                        kk_sjkcnrbh = this.addzsdRow.knowlagezycsbh;
                    } else {
                        kk_sjkcnrbh = this.addzsdRow.skillzycsbh;
                    }
                } else {
                    kk_sjkcnrbh = this.addzsdRow.kk_sjkcnrbh;
                }
                this.$api.courseStandard.KcbzKcnryyq.findsjzsdjnd({
                    data: {
                        "kk_cj": "3",
                        "kk_lx": kk_lx,
                        "kk_kcbzbh": this.BH,
                        "kk_sjkcnrbh": kk_sjkcnrbh
                    }
                }).then(response => {
                    if (response.data.data != undefined) {
                        this.sjzsdjndlist = response.data.data;
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                if (this.selectRow && this.selectColumn) {
                    if (this.selectRow === row && this.selectColumn === column) {
                        return 'background-color: #ffff7f;'
                    }
                }
            },
        },
    }
</script>
<style>
    /*  部分样式必须在非scoped内才起效 */
    #wndrDialog>.el-dialog {
        width: 80%;
        margin-top: 3vh !important;
        margin-bottom: 10px;
    }

    #wndrDialog>.el-dialog>.el-dialog__body {
        height: 80%;
        margin-bottom: 10px;
        overflow-y: auto;
    }

    #wndrDialog>.el-dialog__body>.el-table {
        height: 100%;
        overflow-y: auto;
    }
</style>
<style scoped>
    /*@import "../../assets/css/main.css";*/

    .v-modal {
        z-index: 1000 !important;
    }

    .el-dialog__header {
        font-weight: bold !important;
        border-bottom: 2px rgb(0, 155, 173) solid !important;
    }

    .el-table .cell {
        white-space: pre-line;
    }

    #KCXZ {
        height: 200px
    }

    #SJSL {
        height: 200px
    }

    #KCMB {
        height: 200px
    }

    #KCNRYYQ {
        height: 180px;
        border: none
    }

    #JXHDCK {
        height: 200px
    }

    .fromtitle.new1 {
        text-align: left;
        width: 100%;
        line-height: 50px;
        border-width: 1.5px;
        border-bottom: none;
        display: block;
        font-size: 18px;
        padding: 0 15px;
        border-bottom: 1px solid #dee2e6;
        background: #f6f8f8;
        color: #58666e;
    }

    .inputBox {
        width: 100%;
        margin: 15px 0 !important;
        text-align: right;
        padding-right: 15px;
    }

    .dialog-footer {
        margin-top: -15px;
    }

    .el-form--inline .el-form-item__label {
        background-color: #edf1f2;
    }

    .yropen3 .el-dialog {
        margin-top: 5% !important;
        width: 85% !important;
        height: 80%;
    }

    .yropen3 .el-dialog__body {
        height: 82%;
        padding: 1em !important;
        overflow-y: scroll;
    }

    .urlWJ {
        cursor: pointer;
        margin: 0 10px;
        color: #3A71A8;
        border-bottom: none;
    }

    .urlWJ:hover {
        color: #000;
        border-bottom: 1px #3A71A8 solid;
    }

    .zxstsy {
        padding-left: 20px;
    }

    .status {
        width: 100px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        border: 2px solid;
        border-radius: 8px;
        margin-left: 10px;
        text-align: center;
    }

    .scrollArea /deep/.el-scrollbar .is-vertical {
        width: 15px;
    }

    .uploadTips {
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .fileName {
        margin: 20px 0 20px 0;
        font-size: 16px;
    }

    .formTitle {
        height: 40px;
        line-height: 40px;
        text-align: right;
        font-weight: bold;
        margin-right: 5px;
    }

    .dialog-footer {
        margin-top: -5px;
    }

    .openBoxOpenBox {
        width:100%;
    }

    .openBoxOpenBox /deep/ >div {
        width: 550px !important;
    }

    .mainForm {
        width: calc(100% - 18px);
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// criterion_for_curriculum.vue?42eea795